import React, { useEffect, useState } from "react";
import { apiRequestWithRetry } from "src/services/ClientSideAPIService";
import PostSearch from "./PostSearch";
import SITES from "src/constants/Sites";
import NextImage from "@components/Image/NextImage";
import "./RecentlyPublishedSection.css";

const RecentlyPublishedSection = ({ recentPosts, defaultSiteLogo }) => {
  const [justPublishedSite, setJustPublishedSite] = useState(9);
  const [justPublishedPosts, setJustPublishedPosts] = useState(recentPosts);
  const [siteLogo, setSiteLogo] = useState(defaultSiteLogo);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (justPublishedSite && justPublishedSite === 9) {
      setJustPublishedPosts(recentPosts);
      setSiteLogo(defaultSiteLogo);
    } else {
      fetchJustPublishedPosts(justPublishedSite);
    }
  }, [justPublishedSite]);

  const fetchJustPublishedPosts = async (siteId) => {
    setLoading(true);
    const postData = await apiRequestWithRetry(`posts/${siteId}/category/Books?pagesize=2`);
    setJustPublishedPosts([...postData.posts]);
    setSiteLogo(postData.siteLogo);
    setLoading(false);
  };

  const renderPartnerIcons = (site) => {
    return (
      <NextImage
        publicUrl={`${process.env.S3_IMAGE_URL}/ebb-homepage-partner-logos-${site === justPublishedSite ? "" : "gray-"}${site}.${site === justPublishedSite ? "svg" : "png"}`}
        Alt_Text={site}
        isLazyload={false}
        isFeaturedImage={true}
        width={45}
        height={45}
      />
    );
  };

  const sites = [9, 2, 3, 7, 8];
  return (
    <div className="post-search section-bookmarks">
      <h3>Around the Web: </h3>
      <div className="current-site">
        <NextImage
          publicUrl={`${process.env.S3_IMAGE_URL}/bookmark.png`}
          Alt_Text=""
          width={19}
          height={26}
          isLazyload={false}
        />
        {!loading && (
          <NextImage
            ImageUrl={siteLogo}
            Alt_Text=""
            width={
              justPublishedSite === SITES.EXPLORETHEARCHIVE
                ? 97
                : justPublishedSite === SITES.THE_LINE_UP
                  ? 125
                  : 180
            }
            height={26}
          />
        )}
      </div>
      <div className="icons-list">
        {sites.map((site) => (
          <div
            onClick={() => setJustPublishedSite(site)}
            className={`list-icon ${site === justPublishedSite ? "activeSite" : ""}`}
            key={site}
          >
            {renderPartnerIcons(site)}
          </div>
        ))}
      </div>
      {justPublishedPosts && justPublishedPosts.length > 0 ? (
        <PostSearch
          posts={justPublishedPosts}
          name="bookmarksContent"
          siteId={justPublishedSite}
          renderSubtitle={true}
          showTopImage={false}
        />
      ) : null}
    </div>
  );
};

export default RecentlyPublishedSection;
